import { TypeGroupIds } from './../../../modules/shared/constants/category-groupid.constants';
import { FormGroupDirective } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainService } from './../../../app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfigurationService } from './../../configurationService';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ContactService } from '../../../contacts/contactService';
import { ObjectNames } from '../../../shared/constants';
import { TranslocoService } from '@ngneat/transloco';
import { Answer } from '../constants/constants';
import { catchError, of, tap } from 'rxjs';
import { ContactFieldService } from './contact.service'
import { HttpErrorResponse } from '@angular/common/http';
import { ContactModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { TabView } from "primeng/tabview";
import { Accordion } from "primeng/accordion";

@Component({
  selector: 'app-crm-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class CrmContactsComponent implements OnInit, AfterViewInit {

  @ViewChild('contactTemplateForm') contactTemplateForm: FormGroupDirective;
  @ViewChild(TabView) tabView: TabView;
  @ViewChild(Accordion) accordion: Accordion;

  //contacts
  moduleId: number = ContactModuleId;

  contactStagesAll = []
  contactStages = []
  displayAddContactStage = false;
  displayEditContactTemplate = false;
  displaySwapContactLabels = false;
  displayAddContactData = false;
  configMenuContactItems;
  addEditContactHeader;
  contactStageConfig;
  tempContactStage = {
    "id": 0,
    "name": "",
    "contactAssociationTypeId": 0,
    "contacts": [],
    "count": 0,
    "displayOrder": 0,
    "description": "",
    "createdDate": new Date().toISOString(),
    "updatedDate": new Date().toISOString(),
  }
  contactTemplatesConfig;
  contactTemplatesTemp;
  allContactTemplates = []
  templateContactTemp = {
    "id": 0,
    "templateName": "",
    "createdUser": "",
    createdBy: this.app.user.userId,
    "createdDate": new Date().toISOString(),
    "createdSource": this.app.userIP,
    "updatedSource": this.app.userIP,
    "updatedBy": this.app.user.organizationId,
    "updatedDate": new Date().toISOString(),
    "color": "",
    "isActive": "",
    "labels": [
      { id: 0, labelname: "", code: "", checked: true, width: "12", movable: false, showForDrag: true },
    ]
  }
  availableContactLabels_info = [];
  selectedContactLabels_info = [];
  availableContactLabels_address = [];
  selectedContactLabels_address = [];
  availableContactLabels_addition = [];
  selectedContactLabels_addition = [];
  selectedContactCheck1 = true;
  selectedContactCheck2 = true;
  selectedContactCheck3 = true;
  contactDataTemp;

  emailConfig;
  phoneConfig;
  socialConfig;
  contactTypeId = 0;
  selectedContactDataType;

  contactDataTypes = [
    { id: 6, name: "Annual Income", code: "income" },
    { id: 0, name: "Contact Type", code: "contact type" },
    { id: 7, name: "Degree", code: "degree" },
    { id: 9, name: "Email Types", code: "email type" },
    { id: 8, name: "Field of Study", code: "study field" },
    { id: 1, name: "Gender", code: "gender" },
    { id: 2, name: "Language Spoken", code: "language" },
    { id: 4, name: "Marital Status", code: "marital" },
    { id: 10, name: "Phone Types", code: "phone type" },
    { id: 3, name: "Relationship Status", code: "relation" },
    { id: 11, name: "Social Profile Types", code: "social type" },
    { id: 5, name: "Source of Contact", code: "contact source" },
    { id: 12, name: "Contact Designation", code: "role" },
    { id: 13, name: "Title", code: "title" },
    { id: 14, name: "Active Reason", code: "ContactActivatedReason" },
    { id: 15, name: "Inactive Reason", code: "ContactInactivatedReason" },
    { id: 16, name: "Tags", code: "tags" },
    { id: 17, name: "Contact Role", code: "contact role" },

  ];
  contactTypes = []
  genders = []
  languages = []
  relations = []
  maritals = []
  contactSources = []
  incomes = []
  degrees = []
  studyFields = []
  contactDesignation = []; //contactDesignation
  contactRoles = [];
  salutations = [];

  fieldTypeSelectionError = false;
  invalidData = false;
  currentModule = '';

  configTemp;
  configTempEmail;
  configTempPhone;
  configTempSocial;
  configTempLeadEmail;
  configTempLeadPhone;
  configTempLeadSocial;

  emailtype: any;
  phonetype: any;
  socials: any;
  selectedEmail;
  selectedPhone;
  selectedSocial;

  availableContactEmailLabels = []
  selectedContactEmailLabels = []
  availableContactPhoneLabels = []
  selectedContactPhoneLabels = []
  availableContactSocialLabels = []
  selectedContactSocialLabels = []

  contactTranslate = {
    EditContactStageHeader: "",
    FieldData: "",
    AddFieldDataHeader: "",
    EditFieldDataHeader: "",
    AnnualIncomeDelConfMsg: "",
    ContactTypeDelConfMsg: "",
    DegreeDelConfMsg: "",
    EmailTypeDelConfMsg: "",
    FieldOfStudyDelConfMsg: "",
    GenderDelConfMsg: "",
    LanguageSpokenDelConfMsg: "",
    MaritalStatusDelConfMsg: "",
    PhoneTypeDelConfMsg: "",
    RelationshipStatusDelConfMsg: "",
    SocialProfileTypeDelConfMsg: "",
    SourceofContactDelConfMsg: "",
    RolesDelConfMsg: "",
    TitleDelConfMsg: "",
    DeleteConfHeader: ""
  }

  showAddFieldDataArea: boolean = false;
  showEditFieldDataArea: boolean = false;

  answertypeConstants = Answer;
  activeId: number;
  inactiveId: number;
  activeReason: Array<any> = [];
  inactiveReason: Array<any> = [];
  copiedList = [];
  showActiveBtn: boolean = false;
  index: number = 0;
  activeAccordionIndex: number = 0;

  showEmails: boolean = false;
  showPhones: boolean = false;
  showSocials: boolean = false;
  tagList: any[] = [];
  displayEditTag: boolean = false;
  tempTag: any = { id: 0, name: "", color: "#000000", statusId: 0, isActive: false };

  constructor(
    private service: ConfigurationService,
    public app: AppMainComponent,
    private appMainService: AppMainService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public datepipe: DatePipe,
    private contactService: ContactService,
    private translocoService: TranslocoService,
    private contactFieldService: ContactFieldService
  ) { }

  ngOnInit(): void {
    this.getTranslatedValue();
    this.loadContactSettings();
    //this.loadContactSources();
    //this.loadContactRoles();
    //this.loadSalutation();
    // this.appMainService.isShowSpinner('loadRelations')
    // this.contactService.getRelationshipStatuses().then(status => {
    //   this.relations = status;
    //   this.appMainService.isHideSpinner('loadRelations')
    // }).catch(err => {
    //   this.appMainService.isHideSpinner('loadRelations')
    // });
    // this.appMainService.isShowSpinner('loadMaritals')
    // this.contactService.getAllMaritalStatuses().then(status => {
    //   this.maritals = status;
    //   this.appMainService.isHideSpinner('loadMaritals')
    // }).catch(err => {
    //   this.appMainService.isHideSpinner('loadMaritals')
    // });

    // contacts
    this.configMenuContactItems = [
      {
        label: this.contactTranslate.FieldData,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddContactData('contact');
        }
      },
    ];
    // this.getActiveInactiveReason('ContactActivatedReason');
    // this.getActiveInactiveReason('ContactInactivatedReason');
    //this.loadContactTypes();
    //this.loadTages();
  }

  loadAnnualIncome(fromAdd?) {
    this.appMainService.isShowSpinner('loadAnnualIncome');
    this.contactService.getAnnualIncomes()
      .then(incomes => {
        this.incomes = incomes;
        if (fromAdd) {
          this.copiedList = JSON.parse(JSON.stringify(this.incomes));
        }
        this.appMainService.isHideSpinner('loadAnnualIncome');
      })
      .catch(() => {
        this.appMainService.isHideSpinner('loadAnnualIncome');
      });
  }

  loadContactTypes() {
    this.appMainService.isShowSpinner('loadContactTypes');
    this.contactService.getContactTypes()
      .then(types => {
        this.contactTypes = types || [];
        this.copiedList = JSON.parse(JSON.stringify(this.contactTypes));
        this.appMainService.isHideSpinner('loadContactTypes');
      })
      .catch(() => {
        this.appMainService.isHideSpinner('loadContactTypes');
      });
  }

  loadDegrees(fromAdd?) {
    this.appMainService.isShowSpinner('loadDegree');
    this.contactService.getDegrees().then(degrees => {
      this.degrees = degrees;
      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.degrees));
      }
      this.appMainService.isHideSpinner('loadDegree');
    }).catch(() => {
      this.appMainService.isHideSpinner('loadDegree');
    });
  }

  loadStudyFields(fromAdd?) {
    this.appMainService.isShowSpinner('loadStudyFields');
    this.contactService.getStudyFields().then(fields => {
      this.studyFields = fields;
      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.studyFields));
      }
      this.appMainService.isHideSpinner('loadStudyFields');
    }).catch(() => {
      this.appMainService.isHideSpinner('loadStudyFields');
    });
  }

  loadGenders(fromAdd?) {
    this.appMainService.isShowSpinner('loadGenders');
    this.contactService.getGenders()
      .then(genders => {
        this.genders = genders;
        if (fromAdd) {
          this.copiedList = JSON.parse(JSON.stringify(this.genders));
        }
        this.appMainService.isHideSpinner('loadGenders');
      }).catch(() => {
        this.appMainService.isHideSpinner('loadGenders');
      });
  }

  loadContactSources(fromAdd?) {
    this.appMainService.isShowSpinner('loadContactSources');
    this.contactService.getAllSources(this.app.user.organizationId)
      .then(sources => {
        this.contactSources = sources;
        if (fromAdd) {
          this.copiedList = JSON.parse(JSON.stringify(this.contactSources));
        }
        this.appMainService.isHideSpinner('loadContactSources');
      })
      .catch(() => {
        this.appMainService.isHideSpinner('loadContactSources');
      });
  }

  loadRelations(fromAdd?) {
    this.appMainService.isShowSpinner('loadRelation');
    this.contactService.getRelationshipStatuses().then(degrees => {
      this.relations = degrees;
      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.relations));
      }
      this.appMainService.isHideSpinner('loadRelation');
    }).catch(() => {
      this.appMainService.isHideSpinner('loadRelation');
    });
  }

  loadContactSettings() {
    this.appMainService.isShowSpinner('loadContactConfig')
    this.contactService.getContactConfigurations().subscribe(
      configs => {
        this.appMainService.isHideSpinner('loadContactConfig')

        this.emailConfig = configs.find(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93);
        this.emailtype = this.emailConfig ? JSON.parse(this.emailConfig.configurationDetails[0].configJSONValue) : [];

        this.phoneConfig = configs.find(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 94);
        this.phonetype = this.phoneConfig ? JSON.parse(this.phoneConfig.configurationDetails[0].configJSONValue) : [];

        this.socialConfig = configs.find(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95);
        this.socials = this.socialConfig ? JSON.parse(this.socialConfig.configurationDetails[0].configJSONValue) : [];

        //Contacts
        this.contactTemplatesConfig = configs.find(s => s.name == ObjectNames.CONTACT_TEMPLATE && s.typeId == 99);
        this.allContactTemplates = JSON.parse(this.contactTemplatesConfig.configurationDetails[0].configJSONValue);
        ////console.log('allContactTemplates', this.allContactTemplates)
        this.availableContactLabels_info = this.allContactTemplates[0].labels_info;
        this.selectedContactLabels_info = this.allContactTemplates[0].labels_info;
        this.allContactTemplates[0].labels_info &&
          this.allContactTemplates[0].labels_info.forEach(element => {
            element.name = element.name || element.labelname;
          });
        this.availableContactLabels_address = this.allContactTemplates[0].labels_address;
        this.selectedContactLabels_address = this.allContactTemplates[0].labels_address;
        this.allContactTemplates[0].labels_address &&
          this.allContactTemplates[0].labels_address.forEach(element => {
            element.name = element.name || element.labelname;
          });
        this.availableContactLabels_addition = this.allContactTemplates[0].labels_addition;
        this.selectedContactLabels_addition = this.allContactTemplates[0].labels_addition;
        this.allContactTemplates[0].labels_addition &&
          this.allContactTemplates[0].labels_addition.forEach(element => {
            element.name = element.name || element.labelname;
          });
        this.updateContactHeaderCheckboxStatus();
      },
      err => {
        this.appMainService.isHideSpinner('loadContactConfig')
      }
    )
  }

  getTranslatedValue() {
    this.translocoService.selectTranslate('Configuration.CRM.Edit_Contact_Stage').subscribe((data) => {
      this.contactTranslate.EditContactStageHeader = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Field_Data').subscribe((data) => {
      this.contactTranslate.FieldData = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Add_Field_Data').subscribe((data) => {
      this.contactTranslate.AddFieldDataHeader = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Edit_Field_Data').subscribe((data) => {
      this.contactTranslate.EditFieldDataHeader = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Annual_Income_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.AnnualIncomeDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Gender_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.GenderDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Language_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.LanguageSpokenDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Relationship_Status_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.RelationshipStatusDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Marital_Status_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.MaritalStatusDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Contact_Source_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.SourceofContactDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Contact_Role_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.RolesDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Degree_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.DegreeDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Email_Type_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.EmailTypeDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Phone_Type_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.PhoneTypeDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Social_Type_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.SocialProfileTypeDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Contact_Type_Delete_Conf_MSG').subscribe((data) => {
      this.contactTranslate.ContactTypeDelConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Delete_Confirmation').subscribe((data) => {
      this.contactTranslate.DeleteConfHeader = data;
    });
  }

  updateContactTemplate() {
    this.contactTemplatesTemp = {
      "id": this.contactTemplatesConfig.id,
      "createdSource": this.app.userIP,
      "updatedSource": this.app.userIP,
      createdBy: this.app.user.userId,
      "updatedBy": this.app.user.organizationId,
      "createdDate": new Date().toISOString(),
      "updatedDate": new Date().toISOString(),
      "organizationId": this.contactTemplatesConfig.organizationId,
      "name": this.contactTemplatesConfig.name,
      "description": this.contactTemplatesConfig.description,
      "configJSONSchema": "",
      "configJSONValue": "",
      "objectId": this.contactTemplatesConfig.objectId,
      "levelId": this.contactTemplatesConfig.levelId,
      "levelRecordId": this.contactTemplatesConfig.configurationDetails[0].levelRecordId,
      "categoryId": this.contactTemplatesConfig.categoryId,
      "statusId": 1,
      "typeId": this.contactTemplatesConfig.typeId
    }
    let contactLables_info = JSON.parse(JSON.stringify(this.selectedContactLabels_info));
    let contactLables_address = JSON.parse(JSON.stringify(this.selectedContactLabels_address));
    let contactLables_addition = JSON.parse(JSON.stringify(this.selectedContactLabels_addition));
    this.allContactTemplates[0].labels_info = contactLables_info;
    this.allContactTemplates[0].labels_address = contactLables_address;
    this.allContactTemplates[0].labels_addition = contactLables_addition;
    this.contactTemplatesTemp.configJSONValue = JSON.stringify(this.allContactTemplates);

    this.configTempEmail = {
      "id": this.emailConfig.id,
      "createdSource": this.app.userIP,
      "updatedSource": this.app.userIP,
      createdBy: this.app.user.userId,
      "updatedBy": this.app.user.organizationId,
      "createdDate": new Date().toISOString(),
      "updatedDate": new Date().toISOString(),
      "organizationId": this.emailConfig.organizationId,
      "name": this.emailConfig.name,
      "description": this.emailConfig.description,
      "configJSONSchema": "",
      "configJSONValue": "",
      "objectId": this.emailConfig.objectId,
      "levelId": this.emailConfig.levelId,
      "levelRecordId": this.emailConfig.configurationDetails[0].levelRecordId,
      "categoryId": this.emailConfig.categoryId,
      "statusId": 1,
      "typeId": this.emailConfig.typeId
    }
    this.emailtype = JSON.parse(JSON.stringify(this.selectedContactEmailLabels));
    this.configTempEmail.configJSONValue = JSON.stringify(this.emailtype);

    this.configTempPhone = {
      "id": this.phoneConfig.id,
      "createdSource": this.app.userIP,
      "updatedSource": this.app.userIP,
      createdBy: this.app.user.userId,
      "updatedBy": this.app.user.organizationId,
      "createdDate": new Date().toISOString(),
      "updatedDate": new Date().toISOString(),
      "organizationId": this.phoneConfig.organizationId,
      "name": this.phoneConfig.name,
      "description": this.phoneConfig.description,
      "configJSONSchema": "",
      "configJSONValue": "",
      "objectId": this.phoneConfig.objectId,
      "levelId": this.phoneConfig.levelId,
      "levelRecordId": this.phoneConfig.configurationDetails[0].levelRecordId,
      "categoryId": this.phoneConfig.categoryId,
      "statusId": 1,
      "typeId": this.phoneConfig.typeId
    }
    this.phonetype = JSON.parse(JSON.stringify(this.selectedContactPhoneLabels));
    this.configTempPhone.configJSONValue = JSON.stringify(this.phonetype);

    this.configTempSocial = {
      "id": this.socialConfig.id,
      "createdSource": this.app.userIP,
      "updatedSource": this.app.userIP,
      createdBy: this.app.user.userId,
      "updatedBy": this.app.user.organizationId,
      "createdDate": new Date().toISOString(),
      "updatedDate": new Date().toISOString(),
      "organizationId": this.socialConfig.organizationId,
      "name": this.socialConfig.name,
      "description": this.socialConfig.description,
      "configJSONSchema": "",
      "configJSONValue": "",
      "objectId": this.socialConfig.objectId,
      "levelId": this.socialConfig.levelId,
      "levelRecordId": this.socialConfig.configurationDetails[0].levelRecordId,
      "categoryId": this.socialConfig.categoryId,
      "statusId": 1,
      "typeId": this.socialConfig.typeId
    }
    this.socials = JSON.parse(JSON.stringify(this.selectedContactSocialLabels));
    this.configTempSocial.configJSONValue = JSON.stringify(this.socials);

    this.service.updateConfiguration(this.contactTemplatesTemp).then(() => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact updated successfully...' });
      this.contactService.getContactConfigurations().subscribe(configs => {
        this.contactTemplatesConfig = configs.filter(s => s.name == ObjectNames.CONTACT_TEMPLATE && s.typeId == 99)[0];
        this.allContactTemplates = JSON.parse(this.contactTemplatesConfig.configurationDetails[0].configJSONValue);
        this.availableContactLabels_info = this.allContactTemplates[0].labels_info;
        this.selectedContactLabels_info = this.allContactTemplates[0].labels_info;
        this.availableContactLabels_address = this.allContactTemplates[0].labels_address;
        this.selectedContactLabels_address = this.allContactTemplates[0].labels_address;
        this.availableContactLabels_addition = this.allContactTemplates[0].labels_addition;
        this.selectedContactLabels_addition = this.allContactTemplates[0].labels_addition;
        this.updateContactHeaderCheckboxStatus();
      });

      this.service.updateConfiguration(this.configTempEmail).then(stages => {
        this.contactService.getContactConfigurations().subscribe(configs => {
          this.emailConfig = configs.find(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93);
          this.emailtype = this.emailConfig ? JSON.parse(this.emailConfig.configurationDetails[0].configJSONValue) : [];
        });
      });
      this.service.updateConfiguration(this.configTempPhone).then(stages => {
        this.contactService.getContactConfigurations().subscribe(configs => {
          this.phoneConfig = configs.find(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 94);
          this.phonetype = this.phoneConfig ? JSON.parse(this.phoneConfig.configurationDetails[0].configJSONValue) : [];
        });
      });
      this.service.updateConfiguration(this.configTempSocial).then(stages => {
        this.contactService.getContactConfigurations().subscribe(configs => {
          this.socialConfig = configs.find(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95);
          this.socials = this.socialConfig ? JSON.parse(this.socialConfig.configurationDetails[0].configJSONValue) : [];
        });
      });
      this.displayEditContactTemplate = false;
    }).catch(() => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
    });
  }


  contactDataFormSubmitted = false;
  showAddContactData(loadedModule?) {
    this.fieldTypeSelectionError = false;
    this.contactDataFormSubmitted = false;
    this.currentModule = loadedModule;
    this.displayAddContactData = true;
    this.addEditContactHeader = this.contactTranslate.AddFieldDataHeader;
    this.invalidData = false;
    this.showAddFieldDataArea = true;
    this.showEditFieldDataArea = false;
    this.contactDataTemp = {
      "name": "",
      "description": "",
      "id": 0,
      "code": "",
      "checked": true,
      "groupId": null,
      "organizationId": this.app.user.organizationId
    }
  }

  getContactDataType() {
    switch (this.selectedContactDataType?.name) {
      case 'Annual Income':
        this.activeAccordionIndex = 0;
        break;
      case 'Contact Type':
        this.activeAccordionIndex = 1;
        break;
      case 'Degree':
        this.activeAccordionIndex = 2;
        break;
      case 'Field of Study':
        this.activeAccordionIndex = 4;
        break;
      case 'Gender':
        this.activeAccordionIndex = 5;
        break;
      case 'Language Spoken':
        this.activeAccordionIndex = 6;
        break;
      case 'Marital Status':
        this.activeAccordionIndex = 7;
        break;
      case 'Relationship Status':
        this.activeAccordionIndex = 9;
        break;
      case 'Source of Contact':
        this.activeAccordionIndex = 11;
        break;
      case 'Contact Designation':
        this.activeAccordionIndex = 12;
        break;
      case 'Title':
        this.activeAccordionIndex = 13;
        break;
      case 'Active Reason':
        this.activeAccordionIndex = 14;
        break;
      case 'Inactive Reason':
        this.activeAccordionIndex = 15;
        break;
      case 'Contact Role':
      this.activeAccordionIndex = 17;
      break;
      default:
        this.activeAccordionIndex = 6;
    }
    this.onOpenAccordion(null);
    if (
      this.selectedContactDataType?.code === 'email type' ||
      this.selectedContactDataType?.code === 'phone type' ||
      this.selectedContactDataType?.code === 'social type'
    ) {
      this.contactDataTemp = {
        name: "",
        description: "",
        id: 0,
        code: "",
        checked: false
      };
    }

    else if (this.selectedContactDataType.code == "ContactActivatedReason" || this.selectedContactDataType.code == "ContactInactivatedReason") {
      this.contactDataTemp = {
        "id": 0,
        "createdSource": this.app.userIP,
        "updatedSource": this.app.userIP,
        createdBy: this.app.user.userId,
        "organizationId": this.app.user.organizationId,
        "updatedBy": this.app.user.organizationId,
        "createdDate": new Date().toISOString(),
        "updatedDate": new Date().toISOString(),
        "name": "",
        "description": "",
        "statusId": 1,
        "isActive": true,
        "isDefault": false
      }
    }
    else {
      this.contactDataTemp = {
        "id": 0,
        "createdSource": this.app.userIP,
        "updatedSource": this.app.userIP,
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": new Date().toISOString(),
        "updatedDate": new Date().toISOString(),
        "name": "",
        "parentTypeId": 0,
        "description": "",
        "groupId": 12,
        "group": null,
        "statusId": 1,
        "status": null,
        "organizationId": this.app.user.organizationId,
        "colorCodeId": null
      }
    }
  }

  showEditContactData(c, s, index) {
    this.contactDataFormSubmitted = false;
    this.contactDataTemp = JSON.parse(JSON.stringify(c));
    this.contactDataTemp['isActive'] = this.contactDataTemp.statusId == 1;

    if ([0, 1, 5, 6, 7, 8, 12, 13].includes(s.id)) {
      this.showActiveBtn = true;
    } else {
      this.showActiveBtn = false;
    }

    this.index = index;
    this.contactTypeId = s.id;
    this.addEditContactHeader = this.contactTranslate.EditFieldDataHeader;
    this.displayAddContactData = true;
    this.showAddFieldDataArea = false;
    this.showEditFieldDataArea = true;
  }

  saveContactDataAdd() {
    if (this.showAddFieldDataArea && !this.selectedContactDataType) {
      this.contactDataFormSubmitted = true;
      this.fieldTypeSelectionError = true;
      return false;
    }

    if (this.showAddFieldDataArea) {
      if (this.selectedContactDataType && this.selectedContactDataType?.code == 'contact type') {
        let lowerContactNames = [];
        for (let s of this.contactTypes) {
          lowerContactNames.push(s.name?.toLowerCase());
        }
        if (lowerContactNames?.indexOf(this.contactDataTemp.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.contactDataTemp.groupId = TypeGroupIds.ContactType;
          this.service.addContactType(this.contactDataTemp).then(() => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadContactTypes();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType?.code == 'gender') {
        let lowerContactNames = [];
        for (let s of this.genders) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames?.indexOf(this.contactDataTemp?.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addGender(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadGenders(true);
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'language') {
        let lowerContactNames = [];
        for (let s of this.languages) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames?.indexOf(this.contactDataTemp?.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addLanguage(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadLanguages();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'relation') {
        let lowerContactNames = [];
        for (let s of this.relations) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames?.indexOf(this.contactDataTemp?.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addRelationshipStatus(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadRelations();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'marital') {
        let lowerContactNames = [];
        for (let s of this.maritals) {
          lowerContactNames.push(s.name?.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addMaritalStatus(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadMarial();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'contact source') {
        let lowerContactNames = [];
        for (let s of this.contactSources) {
          lowerContactNames.push(s.name?.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addContactSource(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadContactSources(true);
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType?.code == 'income') {
        let lowerContactNames = [];
        for (let s of this.incomes) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames?.indexOf(this.contactDataTemp.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addAnnualIncome(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadAnnualIncome(true);
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'degree') {
        let lowerContactNames = [];
        for (let s of this.degrees) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames?.indexOf(this.contactDataTemp.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addDegree(this.contactDataTemp).then(() => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadDegrees(true);
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          })
            .catch(err => {
              this.invalidData = false;
              const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail
              });
            });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'study field') {
        let lowerContactNames = [];
        for (let s of this.studyFields) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames?.indexOf(this.contactDataTemp?.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addStudyField(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadStudyFields(true);
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'email type') {
        let lowerContactNames = [];
        for (let s of this.emailtype) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames?.indexOf(this.contactDataTemp?.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.configTemp = {
            "id": this.emailConfig?.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.emailConfig?.organizationId,
            "name": this.emailConfig?.name,
            "description": this.emailConfig?.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.emailConfig?.objectId,
            "levelId": this.emailConfig?.levelId,
            "levelRecordId": this.emailConfig?.configurationDetails[0]?.levelRecordId,
            "categoryId": this.emailConfig?.categoryId,
            "statusId": 1,
            "typeId": this.emailConfig.typeId
          }
          this.contactDataTemp.id = this.emailtype.length + 1;
          this.contactDataTemp.code = 'other';
          this.emailtype.push(this.contactDataTemp);
          this.configTemp.configJSONValue = JSON.stringify(this.emailtype);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getContactConfigurations().subscribe(configs => {
              this.emailConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93)[0];
              this.emailtype = JSON.parse(this.emailConfig.configurationDetails[0].configJSONValue);
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'phone type') {
        let lowerContactNames = [];
        for (let s of this.phonetype) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames?.indexOf(this.contactDataTemp.name?.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.configTemp = {
            "id": this.phoneConfig?.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.phoneConfig?.organizationId,
            "name": this.phoneConfig.name,
            "description": this.phoneConfig?.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.phoneConfig.objectId,
            "levelId": this.phoneConfig.levelId,
            "levelRecordId": this.phoneConfig.configurationDetails[0]?.levelRecordId,
            "categoryId": this.phoneConfig.categoryId,
            "statusId": 1,
            "typeId": this.phoneConfig.typeId
          }
          this.contactDataTemp.id = this.phonetype.length + 1;
          this.contactDataTemp.code = 'other';
          this.phonetype.push(this.contactDataTemp);
          this.configTemp.configJSONValue = JSON.stringify(this.phonetype);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getContactConfigurations().subscribe(configs => {
              this.phoneConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 93)[0];
              this.phonetype = JSON.parse(this.phoneConfig.configurationDetails[0]?.configJSONValue);
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'social type') {
        let lowerContactNames = [];
        for (let s of this.socials) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.configTemp = {
            "id": this.socialConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.socialConfig.organizationId,
            "name": this.socialConfig.name,
            "description": this.socialConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.socialConfig.objectId,
            "levelId": this.socialConfig.levelId,
            "levelRecordId": this.socialConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.socialConfig.categoryId,
            "statusId": 1,
            "typeId": this.socialConfig.typeId
          }
          this.contactDataTemp.id = this.socials.length + 1;
          this.contactDataTemp.code = 'other';
          this.socials.push(this.contactDataTemp);
          this.configTemp.configJSONValue = JSON.stringify(this.socials);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getContactConfigurations().subscribe(configs => {
              this.socialConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95)[0];
              this.socials = JSON.parse(this.socialConfig.configurationDetails[0].configJSONValue);
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'role') {
        let lowerContactNames = [];
        for (let s of this.contactDesignation) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.contactDataTemp.groupId = TypeGroupIds.JobFuctionsContactAPI;
          this.service.addContactRole(this.contactDataTemp).subscribe(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadContactDesignation(true);
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      }
      else if (this.selectedContactDataType && this.selectedContactDataType.code == 'contact role') {
        let lowerContactRoles = [];
        for (let s of this.contactRoles) {
          lowerContactRoles.push(s.name.toLowerCase())
        }
        if (lowerContactRoles.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.contactDataTemp.groupId = TypeGroupIds.contactRolesId;
          this.service.addContactRole(this.contactDataTemp).subscribe(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadContactRoles(true);
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      }
      else if (this.selectedContactDataType && this.selectedContactDataType.code == 'title') {
        let lowerSalutations = [];
        for (let s of this.salutations) {
          lowerSalutations.push(s.name.toLowerCase())
        }
        if (lowerSalutations.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.contactDataTemp.groupId = TypeGroupIds.JobFuctionsContactAPI;
          this.service.addSalutation(this.contactDataTemp).subscribe(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Title Added Successfully...' });
            this.loadSalutation(true);
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.selectedContactDataType.code == 'tags') {
        if (this.contactDataTemp.name?.trim()?.length <= 0) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please write a valid tag name' });
          return;
        } else if (!this.contactDataTemp?.color) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select the tag color' });
          return;
        } else {
          this.addTags();
        }
      }
      else if (this.selectedContactDataType.code == 'ContactActivatedReason' || this.selectedContactDataType.code == 'ContactInactivatedReason') {
        this.addActiveInactiveReason();
      }
    } else if (this.showEditFieldDataArea) {
      if (this.contactTypeId == 0) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }
        const duplicateRecord = this.contactTypes?.find(depOb => depOb.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && depOb.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }
        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.EditContactType(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.loadContactTypes();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 1) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.genders?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }
        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.EditGender(this.contactDataTemp)
            .then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadGenders();
              this.displayAddContactData = false;
              this.selectedContactDataType = null;
              this.invalidData = false;
            })
            .catch(err => {
              this.invalidData = false;
              const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail
              });
            });
        }
      } else if (this.contactTypeId == 2) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.languages?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.EditLanguage(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.loadLanguages();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 3) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.relations.find(obj => obj?.name?.toLowerCase() == this.contactDataTemp?.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.EditRelationshipStatus(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.loadRelations();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 4) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }
        const duplicateRecord = this.maritals.find(obj => obj?.name?.toLowerCase() == this.contactDataTemp?.name?.toLowerCase() && obj.id !== this.contactDataTemp?.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.EditMaritalStatus(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.loadMarial();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 5) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }
        const duplicateRecord = this.contactSources?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.EditContactSource(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.loadContactSources();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 6) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }
        const duplicateRecord = this.incomes?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.EditAnnualIncome(this.contactDataTemp)
            .then(stages => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadAnnualIncome();
              this.displayAddContactData = false;
              this.selectedContactDataType = null;
              this.invalidData = false;
            })
            .catch(err => {
              this.invalidData = false;
              const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail
              });
            });
        }
      } else if (this.contactTypeId == 7) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.degrees?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.EditDegree(this.contactDataTemp)
            .then(stages => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadDegrees();
              this.displayAddContactData = false;
              this.selectedContactDataType = null;
              this.invalidData = false;
            })
            .catch(err => {
              this.invalidData = false;
              const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail
              });
            });
        }
      } else if (this.contactTypeId == 8) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.studyFields?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.EditStudyField(this.contactDataTemp)
            .then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadStudyFields();
              this.displayAddContactData = false;
              this.selectedContactDataType = null;
              this.invalidData = false;
            })
            .catch(err => {
              this.invalidData = false;
              const detail = err.status === 422 ? err.error : err.error.Message;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail
              });
            });
        }
      } else if (this.contactTypeId == 9) {

        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.emailtype?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.configTemp = {
            "id": this.emailConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.emailConfig.organizationId,
            "name": this.emailConfig.name,
            "description": this.emailConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.emailConfig.objectId,
            "levelId": this.emailConfig.levelId,
            "levelRecordId": this.emailConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.emailConfig.categoryId,
            "statusId": 1,
            "typeId": this.emailConfig.typeId
          }
          let arr = [];
          for (let s of this.emailtype) {
            if (s.id == this.contactDataTemp.id) {
              s = JSON.parse(JSON.stringify(this.contactDataTemp));
              arr.push(s)
            } else {
              arr.push(s);
            }
          }
          this.emailtype = JSON.parse(JSON.stringify(arr))
          this.configTemp.configJSONValue = JSON.stringify(this.emailtype);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getContactConfigurations().subscribe(configs => {
              this.emailConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93)[0];
              this.emailtype = JSON.parse(this.emailConfig.configurationDetails[0].configJSONValue);
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 10) {

        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.phonetype?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.configTemp = {
            "id": this.phoneConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.phoneConfig.organizationId,
            "name": this.phoneConfig.name,
            "description": this.phoneConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.phoneConfig.objectId,
            "levelId": this.phoneConfig.levelId,
            "levelRecordId": this.phoneConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.phoneConfig.categoryId,
            "statusId": 1,
            "typeId": this.phoneConfig.typeId
          }
          let arr = [];
          for (let s of this.phonetype) {
            if (s.id == this.contactDataTemp.id) {
              s = JSON.parse(JSON.stringify(this.contactDataTemp));
              arr.push(s)
            } else {
              arr.push(s);
            }
          }
          this.phonetype = JSON.parse(JSON.stringify(arr))
          this.configTemp.configJSONValue = JSON.stringify(this.phonetype);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getContactConfigurations().subscribe(configs => {
              this.phoneConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 93)[0];
              this.phonetype = JSON.parse(this.phoneConfig.configurationDetails[0].configJSONValue);
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 11) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.socials?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.configTemp = {
            "id": this.socialConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.socialConfig.organizationId,
            "name": this.socialConfig.name,
            "description": this.socialConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.socialConfig.objectId,
            "levelId": this.socialConfig.levelId,
            "levelRecordId": this.socialConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.socialConfig.categoryId,
            "statusId": 1,
            "typeId": this.socialConfig.typeId
          }
          let arr = [];
          for (let s of this.socials) {
            if (s.id == this.contactDataTemp.id) {
              s = JSON.parse(JSON.stringify(this.contactDataTemp));
              arr.push(s)
            } else {
              arr.push(s);
            }
          }
          this.socials = JSON.parse(JSON.stringify(arr))
          this.configTemp.configJSONValue = JSON.stringify(this.socials);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getContactConfigurations().subscribe(configs => {
              this.socialConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95)[0];
              this.socials = JSON.parse(this.socialConfig.configurationDetails[0].configJSONValue);
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 12) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.contactDesignation?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.updateContactRole(this.contactDataTemp).subscribe(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Roles Successfully...' });
            this.loadContactDesignation();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      }
      else if (this.contactTypeId == 17) { // for contactRoles  *** previosuly code was written like  with all static Ids sorry i couldn't help you with this
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.contactRoles?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.updateContactRole(this.contactDataTemp).subscribe(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Roles Successfully...' });
            this.loadContactRoles();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 13) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.contactDesignation?.find(obj => obj.name?.toLowerCase() == this.contactDataTemp.name?.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
          this.service.updateSalutation(this.contactDataTemp).subscribe(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Title Successfully...' });
            this.loadSalutation();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
            this.invalidData = false;
          });
        }
      } else if (this.contactTypeId == 14 || this.contactTypeId == 15) {
        this.updateActiveInactiveReason();
      }
    }
  }

  addTags() {
    this.appMainService.isShowSpinner('createTags');
    let newTag: { id: number, name: string, color: string } = {
      id: 0,
      name: this.contactDataTemp?.name.trim(),
      color: this.contactDataTemp?.color
    }

    this.contactFieldService.addTags(newTag)
      .pipe(
        tap((data) => {
          if (data == null) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Duplicate tag names are not allowed.' });
            this.appMainService.isHideSpinner('createTags');
          } else {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadTages();
            this.displayAddContactData = false;
            this.appMainService.isHideSpinner('createTags');
          }
        }),
        catchError(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred.' });
          this.appMainService.isHideSpinner('createTags');
          return of(null)
        }),
      )
      .subscribe();
  }

  loadTages() {
    this.appMainService.isShowSpinner('loadTags');
    this.contactFieldService.getAllTags().subscribe({
      next: (tags) => {
        this.tagList = tags;
        this.appMainService.isHideSpinner('loadTags');
      },
      error: (error: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred.' });
        this.appMainService.isHideSpinner('loadTags');
      }
    })
  }

  showEditTag(tag) {
    this.displayEditTag = true;
    this.tempTag = {
      id: tag?.id,
      name: tag?.name,
      color: tag?.color,
      statusId: tag?.statusId,
      isActive: tag?.statusId == 1 ? true : false,
    }
  }

  saveTag() {
    this.appMainService.isShowSpinner('updateTags');
    let requestBody = {
      id: this.tempTag?.id,
      name: this.tempTag?.name.trim(),
      color: this.tempTag?.color,
      statusId: this.tempTag?.isActive ? 1 : 2,
    }
    this.contactFieldService.editTags(requestBody).subscribe({
      next: (data) => {
        if (data == null) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Duplicate tag names are not allowed.' });
        } else {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Tag is Successfully updated...' });
          this.displayEditTag = false;
          this.loadTages();
          this.appMainService.isHideSpinner('updateTags');
        }
      },
      error: (error: HttpErrorResponse) => {
        // this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred.' });
        this.appMainService.isHideSpinner('updateTags');
      }
    });
  }

  deleteTag(tag) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Tag?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('deleteTags');
        this.contactFieldService.deleteTags(tag?.id).subscribe({
          next: (data) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Tag is Successfully deleted...' });
            this.loadTages();
            this.appMainService.isHideSpinner('deleteTags');
          },
          error: (error: HttpErrorResponse) => {
            // TODO find why error message showing twitch
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.text || 'Can not delete the Tag Associated With Contact.' });
            this.appMainService.isHideSpinner('deleteTags');
          }
        });
      }
    });
  }

  delGender(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.contactTranslate.GenderDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteGender(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getGenders().then(genders => {
            this.genders = genders;
          });
        }).catch((err) => {
          const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail
          });
        });
      }
    });
  }

  delLanguage(c) {
    this.confirmationService.confirm({
      message: this.contactTranslate.LanguageSpokenDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteLanguage(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadLanguages();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delRelationshipStatus(c) {
    this.confirmationService.confirm({
      message: this.contactTranslate.RelationshipStatusDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteRelationshipStatus(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadRelations();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delMaritalStatus(c) {
    this.confirmationService.confirm({
      message: this.contactTranslate.MaritalStatusDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteMaritalStatus(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadMarial();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delContactSource(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.contactTranslate.SourceofContactDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteContactSource(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadContactSources();
        }).catch((reason) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: reason.error.Message });
        });
      },
      reject: () => {
      }
    });
  }

  delContactDesignation(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.contactTranslate.RolesDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteContactRole(c.id).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Role Successfully...' });
          this.loadContactDesignation();
        },
          () => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Cannot delete Designation as it is associted with contacts' });
          });
      }
    });
  }

  delContactRole(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.contactTranslate.RolesDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteContactRole(c.id).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Role Successfully...' });
          this.loadContactRoles();
        },
        (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail : error?.error?.Message || 'Error occurred while deleting data...' });
        });
      }
    });
  }

  delSalutation(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.contactTranslate.RolesDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteSalutation(c.id).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Title Successfully...' });
          this.loadSalutation();
        },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
          });
      }
    });
  }

  delAnnualIncome(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.contactTranslate.AnnualIncomeDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteAnnualIncome(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getAllAnnualIncome().then(incomes => {
            this.incomes = incomes;
          });
        }).catch((err) => {
          const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail
          });
        });
      }
    });
  }

  delDegree(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.contactTranslate.DegreeDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteDegree(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getDegrees().then(degrees => {
            this.degrees = degrees;
          });
        }).catch((err) => {
          const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail
          });
        });
      }
    });
  }

  delEmailType(i) {
    this.confirmationService.confirm({
      message: this.contactTranslate.EmailTypeDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.configTemp = {
          "id": this.emailConfig.id,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          createdBy: this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "organizationId": this.emailConfig.organizationId,
          "name": this.emailConfig.name,
          "description": this.emailConfig.description,
          "configJSONSchema": "",
          "configJSONValue": "",
          "objectId": this.emailConfig.objectId,
          "levelId": this.emailConfig.levelId,
          "levelRecordId": this.emailConfig.configurationDetails[0].levelRecordId,
          "categoryId": this.emailConfig.categoryId,
          "statusId": 1,
          "typeId": this.emailConfig.typeId
        }
        this.emailtype.splice(i, 1);
        this.configTemp.configJSONValue = JSON.stringify(this.emailtype);

        this.service.updateConfiguration(this.configTemp).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getContactConfigurations().subscribe(configs => {
            this.emailConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93)[0];
            this.emailtype = JSON.parse(this.emailConfig.configurationDetails[0].configJSONValue);
          });
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delStudyField(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.contactTranslate.DegreeDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteStudyField(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getStudyFields().then(degrees => {
            this.studyFields = degrees;
          });
        }).catch((reason) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: reason.error.Message });
        });
      }
    });
  }

  delPhoneType(i) {
    this.confirmationService.confirm({
      message: this.contactTranslate.PhoneTypeDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.configTemp = {
          "id": this.phoneConfig.id,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          createdBy: this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "organizationId": this.phoneConfig.organizationId,
          "name": this.phoneConfig.name,
          "description": this.phoneConfig.description,
          "configJSONSchema": "",
          "configJSONValue": "",
          "objectId": this.phoneConfig.objectId,
          "levelId": this.phoneConfig.levelId,
          "levelRecordId": this.phoneConfig.configurationDetails[0].levelRecordId,
          "categoryId": this.phoneConfig.categoryId,
          "statusId": 1,
          "typeId": this.phoneConfig.typeId
        }
        this.phonetype.splice(i, 1);
        this.configTemp.configJSONValue = JSON.stringify(this.phonetype);

        this.service.updateConfiguration(this.configTemp).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getContactConfigurations().subscribe(configs => {
            this.phoneConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 93)[0];
            this.phonetype = JSON.parse(this.phoneConfig.configurationDetails[0].configJSONValue);
          });
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delSocialType(i) {
    this.confirmationService.confirm({
      message: this.contactTranslate.SocialProfileTypeDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.configTemp = {
          "id": this.socialConfig.id,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          createdBy: this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "organizationId": this.socialConfig.organizationId,
          "name": this.socialConfig.name,
          "description": this.socialConfig.description,
          "configJSONSchema": "",
          "configJSONValue": "",
          "objectId": this.socialConfig.objectId,
          "levelId": this.socialConfig.levelId,
          "levelRecordId": this.socialConfig.configurationDetails[0].levelRecordId,
          "categoryId": this.socialConfig.categoryId,
          "statusId": 1,
          "typeId": this.socialConfig.typeId
        }
        this.socials.splice(i, 1);
        this.configTemp.configJSONValue = JSON.stringify(this.socials);

        this.service.updateConfiguration(this.configTemp).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getContactConfigurations().subscribe(configs => {
            this.socialConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95)[0];
            this.socials = JSON.parse(this.socialConfig.configurationDetails[0].configJSONValue);
          });
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delContactType(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.contactTranslate.ContactTypeDelConfMsg,
      header: this.contactTranslate.DeleteConfHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteContactType(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadContactTypes();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  getChangeContact(event) {
    if (this.addEditContactHeader == 'Add Contact Stage' || this.addEditContactHeader == 'Edit Contact Stage') {
      this.tempContactStage.description = event;
    }
    // if (this.addEditContactHeader == 'Add Field Data' || this.addEditContactHeader == 'Edit Field Data') {
    //   this.contactDataTemp.description = event;
    // }
  }

  showEditContactTemplate(c) {
    this.availableContactEmailLabels = this.emailtype.sort((a, b) => a.displayOrder - b.displayOrder);
    this.selectedContactEmailLabels = this.emailtype.sort((a, b) => a.displayOrder - b.displayOrder);
    this.availableContactPhoneLabels = this.phonetype.sort((a, b) => a.displayOrder - b.displayOrder);
    this.selectedContactPhoneLabels = this.phonetype.sort((a, b) => a.displayOrder - b.displayOrder);
    this.availableContactSocialLabels = this.socials.sort((a, b) => a.displayOrder - b.displayOrder);
    this.selectedContactSocialLabels = this.socials.sort((a, b) => a.displayOrder - b.displayOrder);
    this.displayEditContactTemplate = true;
    this.addFields();
  }

  addFields() {
    const emailIndex = this.selectedContactLabels_info.findIndex(el => el.code === 'email');
    this.selectedContactLabels_info[emailIndex].fields = this.selectedContactEmailLabels;

    const phoneIndex = this.selectedContactLabels_info.findIndex(el => el.code === 'phone');
    this.selectedContactLabels_info[phoneIndex].fields = this.selectedContactPhoneLabels;

    const socialIndex = this.selectedContactLabels_info.findIndex(el => el.code === 'social');
    this.selectedContactLabels_info[socialIndex].fields = this.selectedContactSocialLabels;
  }

  updateContactTemplateCancel() {
    this.allContactTemplates = JSON.parse(this.contactTemplatesConfig.configurationDetails[0].configJSONValue);
    this.selectedContactLabels_info = this.allContactTemplates[0].labels_info;
    this.selectedContactLabels_address = this.allContactTemplates[0].labels_address;
    this.selectedContactLabels_addition = this.allContactTemplates[0].labels_addition;

    // const uncheckedLabel = this.selectedContactLabels_info.find(obj => obj.checked  == false)
    // this.selectedContactCheck1 = uncheckedLabel == null;

    // this.selectedContactCheck2 = true;
    // this.selectedContactCheck3 = true;

    this.contactTemplateForm.reset();
    this.displayEditContactTemplate = false;
    this.updateContactHeaderCheckboxStatus();
  }

  updateContactHeaderCheckboxStatus() {
    const uncheckedLabel1 = this.selectedContactLabels_info.find(obj => obj.checked == false)
    this.selectedContactCheck1 = uncheckedLabel1 == null;

    const unSelectedContactCheck2 = this.selectedContactLabels_address.find(obj => obj.checked == false)
    this.selectedContactCheck2 = unSelectedContactCheck2 == null;

    const unSelectedContactCheck3 = this.selectedContactLabels_addition.find(obj => obj.checked == false)
    this.selectedContactCheck3 = unSelectedContactCheck3 == null;
  }

  row1CheckBoxStateValue = false;
  selectedContactRow1(checkValue, newValue) {
    this.row1CheckBoxStateValue = !newValue;
    if (checkValue) {
      for (let s of this.selectedContactLabels_info) {
        s.checked = true;
      }
    } else {
      for (let s of this.selectedContactLabels_info) {
        if (s.movable == true || s.width == 2) {
          s.checked = false;
        }
      }
    }
  }
  selectedContactRow2(checkValue) {
    if (checkValue) {
      for (let s of this.selectedContactLabels_address) {
        s.checked = true;
      }
    } else {
      for (let s of this.selectedContactLabels_address) {
        if (s.movable == true) {
          s.checked = false;
        }
      }
    }
  }
  selectedContactRow3(checkValue) {
    if (checkValue) {
      for (let s of this.selectedContactLabels_addition) {
        s.checked = true;
      }
    } else {
      for (let s of this.selectedContactLabels_addition) {
        if (s.movable == true) {
          s.checked = false;
        }
      }
    }
  }

  showSwapContactLabels(c) {
    this.displaySwapContactLabels = true;
  }
  saveContactLabelsSwap() {

  }
  dropContact(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }


  fetchContactStages() {
    this.appMainService.isShowSpinner('getContatStatges')
    this.service.getContactStages().subscribe(
      stages => {
        this.contactStages = stages;
        this.appMainService.isHideSpinner('getContatStatges');
      },
      err => {
        this.appMainService.isHideSpinner('getContatStatges');
      })
  }

  editContactStage(s) {
    this.tempContactStage = JSON.parse(JSON.stringify(s));
    this.addEditContactHeader = this.contactTranslate.EditContactStageHeader;
    this.displayAddContactStage = true;
  }

  saveContactEditStage() {
    this.service.updateContactStage(this.tempContactStage).subscribe(
      (resp) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact updated successfully...' });
        this.fetchContactStages();
        this.displayAddContactStage = false;
      },
      err => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
      }
    );
  }

  dropColContact(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.contactStages, event.previousIndex, event.currentIndex);
    let arr = [];
    for (let [i, s] of this.contactStages.entries()) {
      let ii = Number(i);
      let temp = this.contactStages[ii];
      temp.displayOrder = ii + 1;
      s = JSON.parse(JSON.stringify(temp));
      arr.push(s)
    }
    this.contactStages = JSON.parse(JSON.stringify(arr));
    let cc = this.contactStagesAll[0]
    this.contactStagesAll = JSON.parse(JSON.stringify(this.contactStages));
    this.contactStagesAll.unshift(cc)
    this.contactStageConfig.configJSONValue = JSON.stringify(this.contactStagesAll);

    this.service.updateConfiguration(this.contactStageConfig).then(stages => {
      this.fetchContactStages();
    });
  }

  loadContactDesignation(fromAdd?) {
    this.appMainService.isShowSpinner('getUsersList');
    this.service.getAllContactRoles().subscribe(
      resp => {
        this.contactDesignation = resp && resp.length ? resp : [];
        if (fromAdd) {
          this.copiedList = JSON.parse(JSON.stringify(this.contactDesignation));
        }
        this.appMainService.isHideSpinner('getUsersList');
      },
      () => {
        this.appMainService.isHideSpinner('getUsersList');
      },
    );
  }

  loadSalutation(fromAdd?) {
    this.appMainService.isShowSpinner('getSalutation');
    this.service.getSalutation().subscribe(
      resp => {
        this.salutations = resp && resp.length ? resp : [];
        if (fromAdd) {
          this.copiedList = JSON.parse(JSON.stringify(this.salutations));
        }
        this.appMainService.isHideSpinner('getSalutation');
      },
      err => {
        this.appMainService.isHideSpinner('getSalutation');
      },
    );
  }

  getActiveInactiveReason(groupName: string, fromAdd?): void {
    this.appMainService.isShowSpinner('getActiveInActiveReasons');

    this.contactService.getActiveInactiveDataByName(groupName).subscribe(
      dataName => {
        this.appMainService.isHideSpinner('getActiveInActiveReasons');
        dataName &&
          this.contactService.getActiveInactiveReasons(dataName.id).subscribe(
            res => {
              if (groupName == 'ContactActivatedReason') {
                this.activeId = dataName.id;
                this.activeReason = res ? res : [];
                this.activeReason.sort((a, b) => a.name.localeCompare(b.name));
                if (fromAdd) {
                  this.copiedList = JSON.parse(JSON.stringify(this.activeReason));
                }
              } else {
                this.inactiveId = dataName.id;
                this.inactiveReason = res ? res : [];
                this.inactiveReason.sort((a, b) => a.name.localeCompare(b.name));

                if (fromAdd) {
                  this.copiedList = JSON.parse(JSON.stringify(this.inactiveReason));
                }
              }
            },
            () => {
              this.appMainService.isHideSpinner('getActiveInActiveReasons');
            });
      },
      () => {
        this.appMainService.isHideSpinner('getActiveInActiveReasons');
      })
  }

  addActiveInactiveReason() {
    let lowerOppNames = [];

    for (let s of (this.selectedContactDataType.code == 'ContactActivatedReason' ? this.activeReason : this.inactiveReason)) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }
    if (lowerOppNames.indexOf(this.contactDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      let addData = {
        ...this.contactDataTemp,
        groupId: (this.selectedContactDataType.code == 'ContactActivatedReason' ? this.activeId : this.inactiveId)
      };
      this.appMainService.isShowSpinner('addActiveInActiveReason');
      this.contactService.addActiveInactiveReason(addData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Added Successfully...' });
        this.getActiveInactiveReason(this.selectedContactDataType.code, true);
        this.displayAddContactData = false;
        this.invalidData = false;
        this.appMainService.isHideSpinner('addActiveInActiveReason');
      }, () => {
        this.displayAddContactData = false;
        this.invalidData = false;
      });
    }
  }

  updateActiveInactiveReason() {
    let lowerOppNames = [];

    const index = this.contactTypeId == 14 ? this.activeReason.findIndex(s => s.id == this.contactDataTemp.id) :
      this.inactiveReason.findIndex(s => s.id == this.contactDataTemp.id);

    if (this.contactTypeId == 14) {
      this.activeReason.splice(index, 1);
    } else {
      this.inactiveReason.splice(index, 1);
    }

    for (let s of (this.contactTypeId == 14 ? this.activeReason : this.inactiveReason)) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }

    if (lowerOppNames.indexOf(this.contactDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      this.contactDataTemp.statusId = this.contactDataTemp.isActive ? 1 : 2;
      let addData = { ...this.contactDataTemp, groupId: this.contactTypeId == 14 ? this.activeId : this.inactiveId };
      this.appMainService.isShowSpinner('updateActiveInActiveReason');
      this.contactService.updateActiveInactiveReason(addData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Updated Successfully...' });
        this.getActiveInactiveReason(this.contactTypeId == 14 ? 'ContactActivatedReason' : 'ContactInactivatedReason');
        this.displayAddContactData = false;
        this.appMainService.isHideSpinner('updateActiveInActiveReason');
        this.invalidData = false;
      }, () => {
        this.displayAddContactData = false;
        this.invalidData = false;
      });
    }
  }

  // _updateDefaultData(updateData) {
  //   this.appMainService.isShowSpinner('updateChannel')
  //   this.contactService.updateActiveInactiveReason(updateData).subscribe(stages => {
  //     this.appMainService.isHideSpinner('updateChannel')
  //   }, () => {
  //     this.appMainService.isHideSpinner('updateChannel')
  //   });
  // }

  makeActiveInactiveDefault(data) {
    let updateData = JSON.parse(JSON.stringify(data));
    if (updateData.groupId == this.activeId) {
      this.activeReason.forEach(element => {
        if (element.id != updateData.id && element.isDefault === true) {
          element.isDefault = false;
          // this._updateDefaultData(element);
        }
        this._updateDefaultData(element);

      });

      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });

    } else {
      this.inactiveReason.forEach(element => {
        if (element.id != updateData.id && element.isDefault === true) {
          element.isDefault = false;
          this._updateDefaultData(element);
        }
      });
    }

    // this.appMainService.isShowSpinner('updateChannel');
    // this.contactService.updateActiveInactiveReason(updateData).subscribe(() => {
    //   this.appMainService.isHideSpinner('updateChannel');
    //   this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
    //   this.getActiveInactiveReason(updateData.groupId == this.activeId ? 'ContactActivatedReason' : 'ContactInactivatedReason');
    // }, () => {
    //   this.appMainService.isHideSpinner('updateChannel');
    // });
  }

  _updateDefaultData(updateData) {
    this.appMainService.isShowSpinner('updateChannel')

    this.contactService.updateActiveInactiveReason(updateData).subscribe({
      next: (stages) => {
        this.appMainService.isHideSpinner('updateChannel');
      },
      error: (error: Error) => {
        this.appMainService.isHideSpinner('updateChannel');
      }
    })
  }

  deleteActiveInactiveReason(c, s) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Do you want to delete this Reason?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.contactService.deleteActiveInactiveReason(c.id).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Deleted Successfully...' });
          if (s.id == 14) {
            this.getActiveInactiveReason('ContactActivatedReason');
          } else {
            this.getActiveInactiveReason('ContactInactivatedReason');
          }
        }, () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      }
    });
  }

  showColumnBlock(code) {
    switch (code) {
      case 'email': {
        this.showEmails = !this.showEmails;
        break;
      }

      case 'phone': {
        this.showPhones = !this.showPhones;
        break;
      }

      case 'social': {
        this.showSocials = !this.showSocials;
        break;
      }
    }
  }

  ngAfterViewInit() {
    this.onTabChange(null);
  }

  onTabChange(event) {
    const selectedTabHeader = this.tabView?.tabs[this.index]?.header;
    switch (selectedTabHeader) {
      case 'Stages':
        this.fetchContactStages();
        break;
      case 'Template':
        this.index = event?.index || 0;
        break;
      default:
        this.activeAccordionIndex = 0;
        this.onOpenAccordion(null);
    }
  }


  onOpenAccordion(event) {
    if (event) {
      this.activeAccordionIndex = (event.index);
    }
    const selectedTabHeader = this.accordion?.tabs[this.activeAccordionIndex]?.header;
    switch (selectedTabHeader) {
      case 'Annual Income':
        this.loadAnnualIncome();
        this.copiedList = JSON.parse(JSON.stringify(this.incomes));
        break;
      case 'Contact Type':
        this.loadContactTypes();
        this.copiedList = JSON.parse(JSON.stringify(this.contactTypes));
        break;
      case 'Degree':
        this.loadDegrees();
        this.copiedList = JSON.parse(JSON.stringify(this.degrees));
        break;
      case 'Field of Study':
        this.loadStudyFields();
        this.copiedList = JSON.parse(JSON.stringify(this.studyFields));
        break;
      case 'Gender':
        this.loadGenders();
        this.copiedList = JSON.parse(JSON.stringify(this.genders));
        break;
      case 'Language Spoken':
        this.loadLanguages();
        break;
      case 'Marital Status':
        this.loadMarial();
        break;
      case 'Relationship Status':
        this.loadRelations();
        break;
      case 'Source of Contact':
        this.loadContactSources();
        this.copiedList = JSON.parse(JSON.stringify(this.contactSources));
        break;
      case 'Contact Designation':
        this.loadContactDesignation();
        this.copiedList = JSON.parse(JSON.stringify(this.contactDesignation));
        break;
      case 'Contact Roles':
      this.loadContactRoles();
      this.copiedList = JSON.parse(JSON.stringify(this.contactRoles));
      break;
      case 'Title':
        this.loadSalutation();
        this.copiedList = JSON.parse(JSON.stringify(this.salutations));
        break;
      case 'Active Reason':
        this.getActiveInactiveReason('ContactActivatedReason');
      case 'Inactive Reason':
        this.getActiveInactiveReason('ContactInactivatedReason');
      default:
        this.loadTages();
    }
  }

  loadLanguages() {
    this.appMainService.isShowSpinner('loadLanguages')
    this.contactService.getAllLanguage().then(languages => {
      this.languages = languages;
      this.appMainService.isHideSpinner('loadLanguages')
    }).catch(err => {
      this.appMainService.isHideSpinner('loadLanguages')
    });
  }

  loadMarial() {
    this.appMainService.isShowSpinner('loadMaritals')
    this.contactService.getAllMaritalStatus().then(status => {
      this.maritals = status;
      this.appMainService.isHideSpinner('loadMaritals')
    }).catch(err => {
      this.appMainService.isHideSpinner('loadMaritals')
    });
  }

  openAccordion(event) {
    switch (event.index) {
      case 0: {
        this.copiedList = JSON.parse(JSON.stringify(this.incomes));
        break;
      }
      case 1: {
        this.copiedList = JSON.parse(JSON.stringify(this.contactTypes));
        break;
      }
      case 2: {
        this.copiedList = JSON.parse(JSON.stringify(this.degrees));
        break;
      }
      case 4: {
        this.copiedList = JSON.parse(JSON.stringify(this.studyFields));
        break;
      }
      case 5: {
        this.copiedList = JSON.parse(JSON.stringify(this.genders));
        break;
      }
      case 11: {
        this.copiedList = JSON.parse(JSON.stringify(this.contactSources));
        break;
      }
      case 12: {
        this.copiedList = JSON.parse(JSON.stringify(this.contactDesignation));
        break;
      }
      case 13: {
        this.copiedList = JSON.parse(JSON.stringify(this.salutations));
        break;
      }
    }
  }

  // Annual Income
  makeAnnualIncomeDefault(data) {
    debugger
    this.incomes.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultAnnualIncome(element);
      }
    });

    this.appMainService.isShowSpinner('makeAnnualIncomeDefault');

    this.service.EditAnnualIncome(data).then(() => {
      this.appMainService.isHideSpinner('makeAnnualIncomeDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadAnnualIncome();
    }, () => {
      this.appMainService.isHideSpinner('makeAnnualIncomeDefault');
    });
  }

  updateDefaultAnnualIncome(updateData) {
    this.appMainService.isShowSpinner('updateDefaultAnnualIncome');
    this.service.EditAnnualIncome(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultAnnualIncome');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultAnnualIncome');
    });
  }

  // Contact Types
  makeContactTypeDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.contactTypes.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultContactType(element);
      }
    });

    this.appMainService.isShowSpinner('makeContactTypeDefault');

    this.service.EditContactType(data).then(() => {
      this.appMainService.isHideSpinner('makeContactTypeDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadContactTypes();
    }, () => {
      this.appMainService.isHideSpinner('makeContactTypeDefault');
    });
  }

  updateDefaultContactType(updateData) {
    this.appMainService.isShowSpinner('updateDefaultContactType');
    this.service.EditContactType(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultContactType');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultContactType');
    });
  }

  // Degree
  makeDegreeDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.degrees.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultDegree(element);
      }
    });

    this.appMainService.isShowSpinner('makeDegreeDefault');

    this.service.EditDegree(data).then(() => {
      this.appMainService.isHideSpinner('makeDegreeDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadDegrees();
    }, () => {
      this.appMainService.isHideSpinner('makeDegreeDefault');
    });
  }

  updateDefaultDegree(updateData) {
    this.appMainService.isShowSpinner('updateDefaultDegree');
    this.service.EditDegree(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultDegree');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultDegree');
    });
  }

  // Field of Study
  makeStudyFieldDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.studyFields.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultStudyField(element);
      }
    });

    this.appMainService.isShowSpinner('makeStudyFieldDefault');

    this.service.EditStudyField(data).then(() => {
      this.appMainService.isHideSpinner('makeStudyFieldDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadStudyFields();
    }, () => {
      this.appMainService.isHideSpinner('makeStudyFieldDefault');
    });
  }

  updateDefaultStudyField(updateData) {
    this.appMainService.isShowSpinner('updateDefaultStudyField');
    this.service.EditStudyField(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultStudyField');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultStudyField');
    });
  }

  // Gender
  makeGenderDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.genders.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultGender(element);
      }
    });
    this.appMainService.isShowSpinner('makeGenderDefault');

    this.service.EditGender(data).then(() => {
      this.appMainService.isHideSpinner('makeGenderDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadGenders();
    }, () => {
      this.appMainService.isHideSpinner('makeGenderDefault');
    });
  }

  updateDefaultGender(updateData) {
    this.appMainService.isShowSpinner('updateDefaultGender');
    this.service.EditGender(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultGender');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultGender');
    });
  }

  // Source of Contact
  makeContactSourceDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.contactSources.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultContactSource(element);
      }
    });

    this.appMainService.isShowSpinner('makeContactSourceDefault');

    this.service.EditContactSource(data).then(() => {
      this.appMainService.isHideSpinner('makeContactSourceDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadContactSources();
    }, () => {
      this.appMainService.isHideSpinner('makeContactSourceDefault');
    });
  }

  updateDefaultContactSource(updateData) {
    this.appMainService.isShowSpinner('updateDefaultContactSource');
    this.service.EditContactSource(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultContactSource');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultContactSource');
    });
  }

  // Roles
  makeContactDesignationDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.contactDesignation.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultContactRole(element);
      }
    });

    this.appMainService.isShowSpinner('makeContactRoleDefault');

    this.service.updateContactRole(data).toPromise().then(() => {
      this.appMainService.isHideSpinner('makeContactRoleDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadContactDesignation();
    }, () => {
      this.appMainService.isHideSpinner('makeContactRoleDefault');
    });
  }

  updateDefaultContactRole(updateData) {
    this.appMainService.isShowSpinner('updateDefaultContactRole');
    this.service.updateContactRole(updateData)
      .toPromise()
      .then(() => {
        this.appMainService.isHideSpinner('updateDefaultContactRole');
      }, () => {
        this.appMainService.isHideSpinner('updateDefaultContactRole');
      });
  }

  makeContactRoleDefault(data) {
    this.contactRoles.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultContactRole(element);
      }
    });

    this.appMainService.isShowSpinner('makeContactRoleDefault');

    this.service.updateContactRole(data).toPromise().then(() => {
      this.appMainService.isHideSpinner('makeContactRoleDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadContactRoles();
    }, () => {
      this.appMainService.isHideSpinner('makeContactRoleDefault');
    });
  }

  // Salutation
  makeSalutationDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.salutations.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultSalutation(element);
      }
    });

    this.appMainService.isShowSpinner('makeSalutationDefault');

    this.service.updateSalutation(data).toPromise().then(() => {
      this.appMainService.isHideSpinner('makeSalutationDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadSalutation();
    }, () => {
      this.appMainService.isHideSpinner('makeSalutationDefault');
    });
  }

  updateDefaultSalutation(updateData) {
    this.appMainService.isShowSpinner('updateDefaultSalutation');
    this.service.updateSalutation(updateData)
      .toPromise()
      .then(() => {
        this.appMainService.isHideSpinner('updateDefaultSalutation');
      }, () => {
        this.appMainService.isHideSpinner('updateDefaultSalutation');
      });
  }

  //#region ContactRoles
  loadContactRoles(fromAdd?: boolean): void {
    this.appMainService.isShowSpinner('getUsersList');
    this.service.getNewAllContactRoles().subscribe({
      next: (resp: any[]) => {
        this.contactRoles = resp?.length ? resp : [];
        if (fromAdd) {
          this.copiedList = structuredClone(this.contactRoles);
        }
        this.appMainService.isHideSpinner('getUsersList');
      },
      error: (err) => {
        console.error('Error fetching contact roles:', err);
        this.appMainService.isHideSpinner('getUsersList');
      }
    });
  }
}
